/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Logout_TitleInputs */

const en_us2_profile_editors_logout_title = /** @type {(inputs: Profile_Editors_Logout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out?`)
};

const pt_br2_profile_editors_logout_title = /** @type {(inputs: Profile_Editors_Logout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair da conta?`)
};

const es_419_profile_editors_logout_title = /** @type {(inputs: Profile_Editors_Logout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cerrar sesión?`)
};

const pt_pt2_profile_editors_logout_title = /** @type {(inputs: Profile_Editors_Logout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar sessão?`)
};

const fr_fr2_profile_editors_logout_title = /** @type {(inputs: Profile_Editors_Logout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter ?`)
};

const de_de2_profile_editors_logout_title = /** @type {(inputs: Profile_Editors_Logout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden?`)
};

const it_it2_profile_editors_logout_title = /** @type {(inputs: Profile_Editors_Logout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uscire dall'account?`)
};

/**
* | output |
* | --- |
* | "Sign out?" |
*
* @param {Profile_Editors_Logout_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_logout_title = /** @type {((inputs?: Profile_Editors_Logout_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Logout_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_logout_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_logout_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_logout_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_logout_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_logout_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_logout_title(inputs)
	return en_us2_profile_editors_logout_title(inputs)
});
export { profile_editors_logout_title as "profile-editors.logout_title" }